import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, ArrowLeft, Home, Search } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { cardVariants, containerVariants } from "@/components/animations/animations-motion";


export default function NotAuthorized() {
  const [, navigate] = useLocation();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <motion.div 
      className="min-h-screen w-full flex items-center justify-center bg-[var(--color-background)] px-4 relative overflow-hidden"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >

      <motion.div
        className="w-full max-w-2xl mx-auto"
        variants={cardVariants}
      >
        <Card className="w-full border-0 shadow-2xl rounded-2xl overflow-hidden bg-white">
          <CardContent className="p-8 md:p-12">
            <div className="text-center">
              {/* Icono animado */}
              <div
                className="flex justify-center mb-6"
              >
                <div className="relative">
                  <div
                    className="w-24 h-24 bg-gradient-to-br from-[var(--color-accent)] to-[var(--color-secondary)] rounded-full flex items-center justify-center shadow-lg"
                  >
                    <AlertCircle className="h-12 w-12 text-white" />
                  </div>
                  <div
                    className="absolute -top-2 -right-2 w-8 h-8 bg-[var(--color-success)] rounded-full flex items-center justify-center"
                  >
                    <Search className="h-4 w-4 text-white" />
                  </div>
                </div>
              </div>

              {/* Texto principal */}
              <div>
                <h1 className="text-6xl md:text-8xl font-bold bg-gradient-to-r from-[var(--color-primary)] to-[var(--color-secondary)] bg-clip-text text-transparent mb-4">
                  Acceso Denegado
                </h1>
                <h2 className="text-3xl md:text-3xl font-bold text-gray-800 mb-4">
                  No tienes permisos para acceder a esta página.
                </h2>
              </div>

              {/* Botones de acción */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <div>
                  <Button
                    onClick={handleGoBack}
                    className="bg-gradient-to-r from-[var(--color-accent)] to-[var(--color-secondary)] hover:-translate-y-1 hover:scale-110 text-white font-semibold px-6 py-3 rounded-lg shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    <ArrowLeft className="h-6 w-6" />
                    Volver Atrás
                  </Button>
                </div>

                <div>
                  <Button
                    onClick={handleGoHome}
                    className="bg-gradient-to-r from-[var(--color-success)] to-emerald-600 hover:-translate-y-1 hover:scale-110 text-white font-semibold px-6 py-3 rounded-lg shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    <Home className="h-6 w-6" />
                    Ir al Inicio
                  </Button>
                </div>
              </div>

              {/* Información adicional */}
              <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200" >
                <p className="text-sm text-blue-700 flex items-center justify-center gap-2">
                  <AlertCircle className="h-4 w-4" />
                  Si crees que esto es un error, contacta al soporte técnico.
                </p>
              </div>

              {/* Enlace de soporte */}
              <div
                className="mt-6"
              >
                <a
                  href="mailto:soporte@almacenute.com"
                  className="py-2 px-2 rounded-md text-[var(--color-accent)] hover:text-white hover:bg-[var(--color-secondary)] font-medium transition-colors duration-200 text-sm"
                >
                  soporte@almacenute.com
                </a>
              </div>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </motion.div>
  );
}